import { defineStore } from 'pinia'
import jwtDecode from 'jwt-decode' // *Nota sobre versão abaixo

const useAuthStore = defineStore('auth', {
  state: () => ({
    accessToken: null,
    funcionalidades: null,
    mfaEmail: null,
    mfaPassword: null,
  }),

  getters: {
    possuiAccessTokenDefinido: state => !!state.accessToken,

    /**
     * Decodifica o token JWT para acessar os dados (Claims)
     * Aqui podemos manter arrow function pois só acessamos o 'state'
     */
    decodedToken: state => {
      if (!state.accessToken) return null
      try {
        return jwtDecode(state.accessToken)
      } catch (error) {
        console.error('Erro ao decodificar token:', error)
        return null
      }
    },

    /**
     * AQUI MUDOU: Usamos função normal para poder usar 'this'
     */
    userRole() {
      // Acessamos o outro getter via 'this'
      const token = this.decodedToken
      if (!token) return null

      return token.role || token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
    },

    /**
     * AQUI MUDOU: Usamos função normal para poder usar 'this'
     */
    atuacaoId() {
      const token = this.decodedToken
      if (!token) return null
      // Converte para Number caso venha string do token, para evitar erros de comparação (===)
      return Number(token.a)
    },

    /**
     * AQUI MUDOU: Acessando o getter userRole via 'this'
     */
    isGestor() {
      return this.userRole === 'Gestor'
    },

    isAgente() {
      return this.userRole === 'Agente'
    },
  },

  actions: {
    setAccessToken(token) {
      this.accessToken = token
    },
    setFuncionalidades(funcionalidades) {
      this.funcionalidades = funcionalidades
    },
    setMfaCredentials(email, password) {
      this.mfaEmail = email
      this.mfaPassword = password
    },
    clearMfaCredentials() {
      this.mfaEmail = null
      this.mfaPassword = null
    },
    clear() {
      this.accessToken = null
      this.funcionalidades = null
      // this.microsoftSignInAuthorizationCode = null // Cuidado: essa variavel nao estava no state
    },
  },

  persist: true,
})

export default useAuthStore
